function roundFloatingPointResidue(value: number): number {
  const rounded = Math.round(value);
  const tolerance = Number.EPSILON * Math.max(1, Math.abs(value)) * 1000;

  return Math.abs(value - rounded) <= tolerance ? rounded : value;
}

function shouldTraversePayload(value: object): boolean {
  if (Array.isArray(value)) return true;

  return Object.getPrototypeOf(value) === Object.prototype;
}

export function sanitizeNumericPayload<T>(payload: T): T {
  if (typeof payload === "number") {
    return roundFloatingPointResidue(payload) as T;
  }

  if (!payload || typeof payload !== "object") {
    return payload;
  }

  if (!shouldTraversePayload(payload)) {
    return payload;
  }

  if (Array.isArray(payload)) {
    return payload.map((item) => sanitizeNumericPayload(item)) as T;
  }

  const sanitized: Record<string, unknown> = {};
  Object.keys(payload).forEach((key) => {
    sanitized[key] = sanitizeNumericPayload(
      (payload as Record<string, unknown>)[key]
    );
  });

  return sanitized as T;
}

export function toScaledInteger(value: number | string, multipler: number) {
  const parsed =
    value === "" || value === null || value === undefined ? 0 : Number(value);

  return Number.isFinite(parsed) ? Math.round(parsed * multipler) : 0;
}
